import React, { useState, useEffect, useContext } from 'react';
import { getStuff, postStuff } from '../helpers/auth'
import { AlertsContext } from './Layout'
import { authenticatedContext } from '../App'
import { ButtonWIcon, MyDateTimePicker, TextInput } from './Inputs'
import { getTimestamp30DaysAgo, getTimestampToday, trucateSecondsFromIsoString } from "../helpers/date_conversion"

import Table from "./Table";

export const EditClientProjects = ({ id, children}) => {


    const [clientData, setClientData] = useState(null);
    const { authenticated, setAuthenticated } = useContext(authenticatedContext);
    const [updateShit, setUpdateShit] = useState(false);
    const [editConnectionContext, setEditConnectionContext] = useState(null);
    const addAlertBanner = useContext(AlertsContext);
    const projEditUrl = `client_projects/${id}`;

    const updateFunct = () => {
        setUpdateShit(!updateShit)
    }
    useEffect(() => {
        updateClientData();
    }, [])

    const emptyAidRecords = {
        for_period: [getTimestamp30DaysAgo(), getTimestampToday()],
        aid_records: []
    }

    function updateClientData() {
        getStuff(`client/${id}/`).then((res) => {
            if (res.status === 200) {
                let client_data = res.data
                client_data.aid_records = emptyAidRecords
                client_data.projects.push({
                    project_id: 0,
                    name: "Souhrn všech projektů"
                })
                setClientData(client_data);
            } else if (res.status === 401) {
                setAuthenticated(false);
            } else {
                console.log("error", res)
                addAlertBanner("Něco se pokazilo", "danger");
            }
        });
    }

    function handleLeaveEnterProj(project_id, linked_from, linked_to, name, days_on_project, edit_exsisting) {
        //client_project_leave_enter

        setEditConnectionContext( <EditConnectionContext 
                                client_id={id}
                                project_id={project_id} linked_from={linked_from}
                                linked_to={linked_to} project_name={name}
                                closeItself={()=>{setEditConnectionContext(null)}}
                                edit_exsisting={edit_exsisting}
                                days_on_project={days_on_project}
                                updateFunct={updateFunct}
                                />
            )

    }

    function handleEditConnection(project_id) {
        console.log("edit connection", project_id)
    }

    if (clientData === null) return (<div>Načítám...</div>)
    return (
        <div className="project-edit-container">
            {editConnectionContext && editConnectionContext}
            <div className="controls-c">
                <p>Zapojení do projektů klienta <b>{clientData.first_name} {clientData.last_name}</b></p>
                {children}
            </div>
            <Table reqUrl={projEditUrl}
                updateShit={updateShit}
                redirectOnRecordClick={false}
                headers={[
                    {
                        name: "Název projektu",
                        dataKey: "name",
                        search: false,
                        sort: false,
                        type: "text"
                    },
                    {
                        name: "Zapojen",
                        dataKey: "is_linked",
                        search: false,
                        sort: false,
                        type: "bool"
                    },
                    {
                        name: "Vstup do projektu",
                        dataKey: "linked_from",
                        search: false,
                        sort: false,
                        type: "time"
                    }, {
                        name: "Výstup z projektu",
                        dataKey: "linked_to",
                        search: false,
                        sort: false,
                        type: "time"
                    },
                    {
                        name: "Dny na projekt",
                        dataKey: "p_on_project",
                        search: false,
                        sort: false,
                        type: "days_on_project"
                    },
                    {
                        name: "Akce",
                        dataKey: false,
                        search: false,
                        sort: false,
                        type: "proj_actions"
                    }
                ]}

                actions={{
                    requestBase: "/project/",
                    recordIdKey: "project_id",
                    controls: {
                        enter_proj_src: "/img/svg/enter.svg",
                        leave_proj_src: "/img/svg/leave.svg",
                        edit_proj_src: "/img/svg/edit.svg",
                        onEnterLeave: handleLeaveEnterProj,
                        onEdit: handleEditConnection,
                        sort: false,
                        search: false

                    }

                }}
            />
        </div>
    )
}

function EditConnectionContext({ client_id, project_id, linked_from, linked_to, project_name, edit_exsisting, closeItself, updateFunct, days_on_project}) {

    const [linkedFrom, setLinkedFrom] = useState(linked_from && trucateSecondsFromIsoString(linked_from));
    const [linkedTo, setLinkedTo] = useState(linked_to && trucateSecondsFromIsoString(linked_to));
    const [daysOnProject, setDaysOnProject] = useState(days_on_project);
    const addAlertBanner = useContext(AlertsContext);


    
    function handleSave() {
            if(linkedFrom >= linkedTo)
                {
                    addAlertBanner("Datum vstupu do projektu nemůže být později než datum výstupu", "warning")
                    return;
                }   
            if(!linkedFrom)
                {
                    addAlertBanner("Datum vstupu do projektu musí být vyplněno", "warning")
                    return;
                }
            if (daysOnProject && !/^\d+$/.test(daysOnProject)) {
                    addAlertBanner("Kolonka 'dny na projektu' musí obsahovat pouze číslice", "warning");
                    return;
                }
            const body = {
                    client_id: client_id,
                    project_id: project_id,
                    linked_from: linkedFrom,
                    linked_to: linkedTo,
                    days_on_project: daysOnProject
                }

            postStuff('client/projects/edit/', body).then((res) => {
                if (res.status === 200) {
                    addAlertBanner("Změny uloženy", "success")
                    updateFunct()
                    closeItself()
                } else if (res.status === 400) {
                    if (res.data.error)
                        addAlertBanner(res.data.error, "warning")
                    else
                        addAlertBanner("Něco se pokazilo", "danger")
                } else if(res.status === 403){
                    addAlertBanner("Na editování zapojení do projektů nemáte dostatečné oprávnění", "warning")
                }else {
                    addAlertBanner("Něco se pokazilo", "danger")
                }
        });
    }

    return (
        <div className='blur-container'>
            <div className='edit-connection-context'>
                <div className='edit-connection-context-header'>
                    <h1>{project_name}</h1>
                    <ButtonWIcon iconSrc={"/img/svg/close_round_red.svg"} onClick={closeItself} style={{ backgroundColor: "white" }} />
                </div>
                <table className='edit-connection-t'>
                    <thead>
                    </thead>
                    <tbody>
                        { (!linked_from || edit_exsisting) &&
                            <tr>
                                <td>Zapojen od</td>
                                <td> <MyDateTimePicker value={linkedFrom} setValue={setLinkedFrom} /></td>
                            </tr>
                        }
                        {((!linked_to && linked_from) || edit_exsisting) &&
                            <tr>
                                <td>Zapojen do</td>
                                <td><MyDateTimePicker value={linkedTo} setValue={setLinkedTo} /></td>
                            </tr>
                        }
                        <tr>
                            <td>Dny na projektu</td>
                            <td><TextInput value={daysOnProject} setValue={setDaysOnProject} key={"text_input"}/></td>
                        </tr>
                    </tbody>
                </table>
                <div className='edit-connection-context-controls'>
                    <ButtonWIcon
                    iconSrc={"/img/svg/save.svg"}
                    onClick={handleSave}
                    style={{ backgroundColor: "#68E965" }}
                    text={"Uložit"} />
                </div>
            </div>
        </div>
    )
}